<template>
  <router-link :to="to" class="link">
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="20">
        <path fill="currentColor" d="M.38 19.01c.49.49 1.28.49 1.77 0l8.31-8.31a.996.996
        0 0 0 0-1.41L2.15.98a1.25 1.25 0 0 0-1.77 0 1.25 1.25 0 0 0
        0 1.77L7.62 10 .37 17.25c-.48.48-.48 1.28.01 1.76Z"
        />
    </svg>
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: ['to'],
};
</script>

<style lang="scss" scoped>
.link {
  color: var(--text-primary);
  display: flex;
  align-items: center;
  font-size: 16px;

  svg {
    transform: rotate(180deg) scale(0.7);
    transform-origin: center;
    margin-right: 7px;
    margin-top: 1px;
  }
}
</style>
